import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable } from 'rxjs';
import { delay, map, mergeMap, switchMap, tap} from 'rxjs/operators';
import * as fromAction from './payment.action';
import { PaymentApiService } from '../services/payment.api.service';
import { PaymentStoreService } from './payment.store.service';
import { Router } from '@angular/router';
import { PaymentIntent } from '../../models/paymentIntent';
import { NgxUiLoaderService } from "ngx-ui-loader";
import { GoogleAnalyticsService } from "@core/services/google-analytics.service";
import { paymentFeatureKey } from './payment.state';
import { EffectHelperService } from '@modules/core/services/effect-helper.service';

@Injectable()
export class PaymentStoreEffects {
  constructor(
    private paymentApiService: PaymentApiService,
    private actions$: Actions,
    private ngxService: NgxUiLoaderService,
    private paymentStoreService: PaymentStoreService,
    private router: Router,
    private googleAnalyticsService: GoogleAnalyticsService,
    private effectHelperService: EffectHelperService
  ) {}

  
  // fecthPaymentEffect$: Observable<Action> = this.actions$.pipe(
  //     ofType<fromAction.FetchPayments>(fromAction.FETCH_PAYMENTS),
  //     map(action => action.payload),
  //     switchMap(payload =>
  //         this.paymentApiService
  //             .getAllPayments(payload.name, payload.pageIndex, payload.pageSize, payload.guideId, payload.experienceId, payload.userId)
  //             .pipe(map(res => {
  //                 this.paymentStoreService.addTotalCount(res);
  //                 return res.body;
  //             }))
  //             .pipe(
  //                 map(
  //                     items => new fromAction.AddPayments({ payments: items })
  //                 ),
  //                 catchError(error =>
  //                     observableOf(this.rootStoreService.handleError(error))
  //                 )
  //             )
  //     )
  // );

  
  // getByIdEffect$: Observable<Action> = this.actions$.pipe(
  //     ofType<fromAction.GetPayment>(fromAction.GET_PAYMENT),
  //     map(action => action.payload),
  //     switchMap(payload =>
  //         this.paymentApiService
  //             .getPaymentById(payload.id)
  //             .pipe(
  //                 map(
  //                     payment =>
  //                         new fromAction.AddPayment({ payment: payment })
  //                 ),
  //                 catchError(error =>
  //                     observableOf(this.rootStoreService.handleError(error))
  //                 )
  //             )
  //     )
  // );

  
  // registerPaymentEffect$: Observable<Action> = this.actions$.pipe(
  //   ofType(fromAction.RegisterPayment),
  //   switchMap((payload) =>
  //     this.paymentApiService.registerPayment(payload.change).pipe(
  //       map((payment) => {
  //         if (payment.status == 'SUCCEEDED') {
  //           this.router.navigate(['/payment/thankyou']);
  //         } else if (payment.status == 'CREATED') {
  //           window.location.href = payment.secureModeRedirectUrl;
  //         }
  //         return fromAction.AddPayment({ payment: payment });
  //       })
  //     )
  //   )
  // );

 
  fetchPaymentIntentEffect$: Observable<Action> = createEffect(() =>this.actions$.pipe(
    ofType(fromAction.FetchPaymentIntent),
    mergeMap((payload) => {
      return this.paymentApiService.directPayment(payload.paymentIntentParams, payload.isAgreedAgeRestriction).pipe(
        map((paymentIntent: PaymentIntent) => this.effectHelperService.handleSuccess(fromAction.AddPaymentIntent({ paymentIntent }))),
        this.effectHelperService.handleError(fromAction.AddError, true, paymentFeatureKey)
      );
    })
  ));

  
  directPaymentTransactionEffect$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType(fromAction.ConfirmPaymentTransaction),
    switchMap(({ transactionId, booking , participants}) => {
      return this.paymentApiService.directPaymentTransaction(transactionId).pipe(
        map((paymentIntent: PaymentIntent) => {
          this.ngxService.start();
          return paymentIntent;
        }),
        delay(2000),
        tap((paymentIntent) => {
          this.ngxService.stop();
          if (booking.serviceRef.bookingType === 'Course' || booking.serviceRef.bookingType === 'Classroom' || booking.serviceRef.bookingType === 'Service') {
            this.router.navigate(['/payment/thankyou', paymentIntent.booking.id]);
          } else {
            this.router.navigate(['/booking/mine-bookinger','kurs','aktiv']);
          }
          if (paymentIntent.status === 'succeeded') {
            this.googleAnalyticsService.addBookingPurchaseToAnalytics(booking,paymentIntent,participants);
            this.paymentStoreService.removePaymentIntent();
          }
        })
      );
    }),
    this.effectHelperService.handleError(fromAction.AddError, true, paymentFeatureKey)
  ));


  directGiftCardPaymentTransactionEffect$: Observable<Action> = createEffect(() => this.actions$.pipe(
      ofType(fromAction.ConfirmGiftCardPaymentTransaction),
      switchMap((payload) => {
        return this.paymentApiService.giftCardPayment(payload.giftCard).pipe(
          map((paymentIntent: PaymentIntent) => {
            this.googleAnalyticsService.addBookingPurchaseToAnalytics(payload.booking,paymentIntent,1);
            this.router.navigate(['/payment/thankyou', paymentIntent.booking.id], {replaceUrl: true});
            return this.effectHelperService.handleSuccess(paymentIntent, true, 'gift_card_success', paymentFeatureKey );
          }),
          this.effectHelperService.handleError(fromAction.AddError, true, paymentFeatureKey)
        );
      })
    )
  );

  
  checkGiftCardEffect$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType(fromAction.CheckGiftCardCode),
    mergeMap((payload) => {
      return this.paymentApiService.checkGiftCardStatus(payload.giftCode, payload.bookingId).pipe(
        map(() => this.effectHelperService.handleSuccess(fromAction.AddGiftCard({ isValid: true }))),
        this.effectHelperService.handleError(fromAction.AddError, true, paymentFeatureKey)
      );
    })
  ));

}
